<template>
  <div id="app">
    <router-view></router-view> <!-- 路由匹配到的组件将渲染在这里 -->
  </div>


</template>

<script>
export default {
  name: 'App',
}
</script>

<style>

/* 强制覆盖所有Ant Design输入框的placeholder */
.custom-input-group .ant-input::placeholder {
  color: #f8f8f8e4 !important;
  opacity: 1 !important;
  background: #000;
}

.custom-theme .ant-input::placeholder {
  color: #f8f8f8e4 !important;
  opacity: 1 !important;
  background: #000;
}

.form-item .ant-input::placeholder {
  color: #f8f8f8e4 !important;
  opacity: 1 !important;
  background: #000;
}



#app {
  height: 100vh;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background: #f8f8f8;
}

@media (max-width: 560px) {
  .mobile-padding {
    padding-left: 20px !important;
    padding-right: 20px !important;
  }
}



</style>
